module.exports = __webpack_public_path__ + "img/Path 2269.6723fca9.svg";